import { GET } from '@/lib/api/Methods';
import { TSession } from './kyc.types';
import { User } from '@/core/models';

export const getKycSession = () => GET<never, TSession>('/kyc/get-session');

export const kycSuccess = (sessionId: string) => GET<never, User>(`/kyc/kyc-success/${sessionId}`);
